module.exports = __webpack_public_path__ + "static/media/bi.58ff9c34.svg";